import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { DosingCalculator } from "@/components/DosingCalculator";
import { api, parseMg } from "@/lib/api";

export default function Dosing() {
  const [products, setProducts] = useState([]);
  const [pick, setPick] = useState("");

  useEffect(() => {
    api.get("/shop/products").then((r) => setProducts(r.data.filter((p) => p.category === "peptide"))).catch(() => {});
  }, []);

  const p = products.find((x) => x.id === pick);
  const initial = p ? { mg: parseMg(p.vial_size) ?? "", ml: p.recommended_bac_ml || "" } : {};

  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:py-14">
      <p className="eyebrow mb-3">Tools</p>
      <h1 className="text-4xl font-bold sm:text-5xl">Reconstitution calculator</h1>
      <p className="mb-8 mt-3 max-w-xl text-muted-foreground">Work out a reconstituted vial's concentration and how much to draw with a U-100 syringe. Pick a product to fill in the vial details, or type your own.</p>
      <div className="rounded-lg border border-border border-t-2 border-t-emerald-500 bg-card p-6">
        <div className="mb-6 space-y-1.5">
          <Label>Start from a product (optional)</Label>
          <Select value={pick} onValueChange={setPick}>
            <SelectTrigger data-testid="dosing-product-select"><SelectValue placeholder="Choose a peptide" /></SelectTrigger>
            <SelectContent>
              {products.map((x) => <SelectItem key={x.id} value={x.id}>{x.name} {x.vial_size}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <DosingCalculator key={pick || "blank"} initial={initial} />
      </div>
    </div>
  );
}
